import { render, staticRenderFns } from "./thirdPartyOrder.vue?vue&type=template&id=33b80591&"
import script from "./thirdPartyOrder.vue?vue&type=script&lang=ts&"
export * from "./thirdPartyOrder.vue?vue&type=script&lang=ts&"
import style0 from "./thirdPartyOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports